import { useEffect } from 'react';

import { useGigyaStore } from '@ciam/gigya-api';

export const ValidateAllDone = () => {
  const loadGigyaSaml = useGigyaStore((state) => state.loadGigyaSaml);

  useEffect(() => {
    loadGigyaSaml();
  }, [loadGigyaSaml]);

  return null;
};
